import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { InfoAlternateIcon } from '@treams/treams-icons';
import {
	Drawer,
	FlexGap,
	Heading3,
	MarkdownStyled,
	UnderlineLink,
	tokens,
} from '@treams/treams-ui';

const LinkButton = styled(UnderlineLink).attrs({ as: 'button', type: 'button', small: true })`
	display: inline-flex;
	align-items: center;
	gap: ${tokens.gap.inline}px;
	flex-shrink: 0;
	text-align: left;
	white-space: normal;

	svg {
		display: block;
		flex-shrink: 0;
	}
`;

const Body = styled(MarkdownStyled)`
	color: ${tokens.text.secondary};
	font-size: ${tokens.typography.sizes.body}px;
	line-height: ${tokens.typography.lineHeights.body};
	font-family: ${tokens.typography.fontFamily};
`;

export function TreamsScoreHowCalculated() {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	return (
		<>
			<LinkButton color="secondary" onClick={() => setOpen(true)}>
				{t('analytics.treamsScore.explanation.title')}
				<InfoAlternateIcon size={16} />
			</LinkButton>
			<Drawer
				open={open}
				onClose={() => setOpen(false)}
				ariaLabel={t('analytics.treamsScore.explanation.title')}
				closeLabel={t('common.close')}
			>
				<Box p={`${tokens.padding.container}px`} pt="48px">
					<FlexGap flexDirection="column" gap={tokens.gap.group}>
						<Heading3>{t('analytics.treamsScore.explanation.title')}</Heading3>
						<Body
							dangerouslySetInnerHTML={{
								__html: t('analytics.treamsScore.explanation.body'),
							}}
						/>
					</FlexGap>
				</Box>
			</Drawer>
		</>
	);
}
